/**
 * StaffPortalProfileService
 * Service for staff profile operations in the portal.
 * Route: api/staff-portal/profile
 */
import { StaffPortalBaseService } from './StaffPortalBaseService';
/**
 * StaffPortalProfileService
 * Handles profile operations for the staff portal.
 * Maps to /api/staff-portal/profile endpoint
 */
export class StaffPortalProfileService extends StaffPortalBaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? StaffPortalProfileService.DEFAULT_SERVICE_PATH,
            basePath: config?.basePath ?? StaffPortalProfileService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== GET PROFILE ====================
    /**
     * Get the current staff member's profile
     * GET /api/staff-portal/profile
     */
    async getProfile() {
        const response = await this.getProfileRaw();
        if (!response.data) {
            throw new Error('Profile not found');
        }
        return response.data;
    }
    /**
     * Get profile (raw response)
     */
    getProfileRaw() {
        return this.get();
    }
    // ==================== UPDATE PROFILE ====================
    /**
     * Update the current staff member's profile (limited fields only)
     * Note: Staff cannot update TypeID, StatusID, StartDate, or EndDate
     * PUT /api/staff-portal/profile
     */
    async updateProfile(data) {
        const response = await this.updateProfileRaw(data);
        if (!response.data) {
            throw new Error('Failed to update profile');
        }
        return response.data;
    }
    /**
     * Update profile (raw response)
     */
    updateProfileRaw(data) {
        return this.put('', data);
    }
}
StaffPortalProfileService.DEFAULT_SERVICE_PATH = 'hr';
StaffPortalProfileService.BASE_PATH = 'api/staff-portal/profile';
//# sourceMappingURL=StaffPortalProfileService.js.map